/* eslint-disable react/require-default-props,jsx-a11y/anchor-is-valid */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Collapse from 'react-collapse';
import { FontAwesome } from '../../FontAwesome';

import { Cohort } from '../../../../CustomPropTypes/CohortPropTypes';
import { Course } from '../../../../CustomPropTypes/CoursePropTypes';
import { ROUTE_COURSE_PAGE } from '../../../../ReduxStorage/routeActions';
import {
  institutionPrefixFromPath,
  courseCodeFromPath,
} from '../../../../ReduxStorage/helpers/paths';
import { RouteLink } from '../../RouteLink/component';

export class CourseNavigationListCourseItem extends React.Component {
  static propTypes = {
    course: Course,
    cohorts: PropTypes.arrayOf(Cohort),
  };

  state = {
    isOpened: false,
  };

  toggleCohorts = (e) => {
    const { isOpened } = this.state;

    e.preventDefault();
    this.setState({ isOpened: !isOpened });
  };

  render() {
    const { course, cohorts } = this.props;
    const { isOpened } = this.state;

    const institutionPrefix = institutionPrefixFromPath(course.path);
    const courseCode = courseCodeFromPath(course.path);

    if (cohorts.length > 1) {
      return (
        <div className="course-navigation-list-item-expandable">
          <a
            className={classNames(
              'site-navigation-menu-link',
              'site-navigation-menu-link-expandable',
              'site-navigation-menu-link-course',
              {
                expanded: isOpened,
              }
            )}
            title={course.name}
            onClick={this.toggleCohorts}
            href="#"
          >
            {course.name}
            <FontAwesome
              name={isOpened ? 'chevron-down' : 'chevron-right'}
              className="site-navigation-menu-chevron"
            />
          </a>
          <Collapse {...{ isOpened }}>
            <ul className="site-navigation-menu-class-list">
              {cohorts.map((cohort) => (
                <li key={cohort.path}>
                  <RouteLink
                    to={{
                      type: ROUTE_COURSE_PAGE,
                      state: {
                        institutionPrefix,
                      },
                      params: {
                        courseCode,
                        subPath: undefined,
                      },
                      query: {
                        inCohort: cohort.path,
                      },
                    }}
                    className={classNames(
                      'site-navigation-menu-link',
                      'site-navigation-menu-link-cohort'
                    )}
                    title={cohort.title}
                  >
                    {cohort.title}
                  </RouteLink>
                </li>
              ))}
            </ul>
          </Collapse>
        </div>
      );
    }

    return (
      <RouteLink
        to={{
          type: ROUTE_COURSE_PAGE,
          state: {
            institutionPrefix,
          },
          params: {
            courseCode,
            subPath: undefined,
          },
          query: {
            inCohort: cohorts[0].path,
          },
        }}
        className={classNames(
          'site-navigation-menu-link',
          'site-navigation-menu-link-course'
        )}
        title={course.name}
      >
        {course.name}
      </RouteLink>
    );
  }
}
